/**
 * 新客服 H5（channelId + userParams.visitorId）
 * 客服侧只展示会员 ID。
 */

export const KEFU_CHAT_BASE = "https://bie.dot04bpz.lol/chat/index";
export const KEFU_CHANNEL_ID = "858bd67a123044b59de3021f5e849706";

/** 业务用户 ID（不要用 token） */
export function resolveMemberId(vm) {
  const store = vm && vm.$store;
  const state = (store && store.state) || {};
  const getters = (store && store.getters) || {};
  const userInfo =
    getters.getUserInfo ||
    state.userInfo ||
    state.user ||
    (vm && vm.userInfo) ||
    null;

  const fromInfo =
    userInfo &&
    (userInfo.id || userInfo.user_id || userInfo.uid || userInfo.member_id);
  if (fromInfo != null && String(fromInfo).trim()) {
    return String(fromInfo).trim();
  }

  // 未拉到 userInfo 时，先请求一次再打开（由 openKefuContact 可选调用）
  return (
    localStorage.getItem("id") ||
    localStorage.getItem("user_id") ||
    localStorage.getItem("uid") ||
    ""
  );
}

/**
 * 拼客服 H5 地址，带上客户 ID（visitorId / visitorName / 会员ID）
 */
export function buildKefuChatUrl(userId, options = {}) {
  const channelId = options.channelId || KEFU_CHANNEL_ID;
  const base = options.baseUrl || KEFU_CHAT_BASE;
  const id = String(userId || "").trim();

  const query = [`channelId=${encodeURIComponent(channelId)}`];

  if (id) {
    const userParams = {
      visitorId: id,
      visitorName: id,
      createCustomer: true,
    };
    const otherParams = {
      会员ID: id,
    };
    query.push(`userParams=${encodeURIComponent(JSON.stringify(userParams))}`);
    query.push(`otherParams=${encodeURIComponent(JSON.stringify(otherParams))}`);
  }

  return `${base}?${query.join("&")}`;
}

export function openKefuChatUrl(url, options = {}) {
  if (!url) {
    return false;
  }
  if (options.newTab) {
    window.open(url, "_blank");
  } else {
    window.location.href = url;
  }
  return true;
}
